// generate a skeleton component for AppFileUpdateForm
const AppFileUpdateFormSkeleton = () => {
  return (
    <div className="space-y-6 max-w-3xl py-8 text-left animate-pulse">
      <div className="bg-white p-6 rounded-md shadow-sm">
        <div className="mb-4">
          <div className="h-4 bg-gray-200 rounded w-24 mb-2"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
        </div>
        <div className="mb-4">
          <div className="h-4 bg-gray-200 rounded w-32 mb-2"></div>
          <div className="h-20 bg-gray-200 rounded"></div>
        </div>
      </div>
      <div className="mt-6 flex justify-end gap-4">
        <div className="h-10 w-24 bg-gray-200 rounded"></div>
        <div className="h-10 w-28 bg-gray-200 rounded"></div>
      </div>
    </div>
  );
};

export default AppFileUpdateFormSkeleton;